<script>
  export let searchTerm = "";
  export let placeholder = "Everyting";
  export let flexGrow = false;
  function handleInput() {}
</script>

<div class="search_wrapper" class:grow={flexGrow === true}>
  <div class="search">
    <div class="searchicon">
      <svg
        height="100%"
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.1466 24L14.8751 14.4151C14.077 15.0963 13.1462 15.6125 12.0828 15.9637C11.0193 16.3149 9.96862 16.4906 8.9306 16.4906C6.45541 16.4906 4.36059 15.6939 2.64614 14.1005C0.931688 12.5071 0.0744629 10.5574 0.0744629 8.25144C0.0744629 5.94545 0.928225 3.99371 2.63575 2.39623C4.3433 0.798742 6.42958 0 8.89461 0C11.3596 0 13.4579 0.797296 15.1894 2.39189C16.921 3.98645 17.7867 5.93492 17.7867 8.23728C17.7867 9.26149 17.5845 10.2704 17.1802 11.2642C16.7758 12.2579 16.2231 13.1069 15.5222 13.8113L25.7937 23.3585L25.1466 24ZM8.9306 15.6604C11.1705 15.6604 13.0582 14.9497 14.5938 13.5283C16.1293 12.1069 16.8971 10.3459 16.8971 8.24528C16.8971 6.14465 16.1293 4.38365 14.5938 2.96226C13.0582 1.54088 11.1705 0.830189 8.9306 0.830189C6.69074 0.830189 4.80302 1.54088 3.26744 2.96226C1.7319 4.38365 0.964121 6.14465 0.964121 8.24528C0.964121 10.3459 1.7319 12.1069 3.26744 13.5283C4.80302 14.9497 6.69074 15.6604 8.9306 15.6604Z"
          fill="var(--pax-black)"
        />
      </svg>
    </div>
    <input
      type="text"
      bind:value={searchTerm}
      placeholder="Search for {placeholder}"
      on:input={handleInput}
    />
  </div>
</div>

<style>
  .search_wrapper {
    width: 100%;
  }

  .search {
    border: 1px solid var(--pax-black);
    border-radius: 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 1rem;
    background-color: var(--pax-white);
  }

  .searchicon {
    height: 1.5rem;
  }

  input {
    border: none;
    padding-left: 1rem;
    border-radius: 0.5rem;
    background-color: var(--pax-white);
    height: 2.5rem;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input:focus,
  input:active {
    outline: none;
  }

  .grow {
    flex-grow: 1;
  }
</style>
